import { INITIATIVE } from '@constants/terminology';

export const BreakoutPlaceholder = () => (
  <div
    role='status'
    className='h-100 d-flex flex-column justify-content-center align-items-center text-center text-ThemeTextMedium px-3'
  >
    <i
      role='img'
      aria-label='Warning'
      className='fal fa-triangle-exclamation fa-2x mb-2 text-ThemeWarningDark'
    />
    <div className='fs-5 fw-bold'>Grouping not supported in this view</div>
    <div className='fs-6 fw-medium mt-1'>
      Switch to a single {INITIATIVE.SINGULAR} to see this chart.
    </div>
  </div>
);
